export default "__VITE_ASSET__fc926463__"